import { useState } from 'react';
import { Dialog, Flex, IconButton } from '@elementary/common-ui/components';
import { ReactComponent as DeleteIcon } from '@elementary/common-ui/assets/trash.svg';
import { Tooltip } from '@mui/material';

type Props = {
  tooltip: string;
  confirmTitle: string;
  confirmMessage: string;
  confirmText: string;
  onConfirm: () => Promise<unknown>;
  isLoading: boolean;
};

const RemoveRowButton = ({
  tooltip,
  confirmTitle,
  confirmMessage,
  confirmText,
  onConfirm,
  isLoading,
}: Props) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  return (
    <Flex sx={{ justifyContent: 'flex-end' }}>
      <Tooltip title={tooltip} placement="left">
        <IconButton aria-label={tooltip} onClick={() => setIsConfirmOpen(true)}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <Dialog
        open={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        onConfirmButtonClick={async () => {
          await onConfirm();
          setIsConfirmOpen(false);
        }}
        title={confirmTitle}
        message={confirmMessage}
        confirmText={confirmText}
        isLoading={isLoading}
        confirmDisabled={isLoading}
        variant="error"
      />
    </Flex>
  );
};

export default RemoveRowButton;
